import { parse as parseFns, format as formatFns } from "date-fns";
import { es, enUS, type Locale } from "date-fns/locale";

export function parse(dateStr: string, format: string): Date {
  return parseFns(dateStr, format, new Date());
}

export function format(
  date: Date,
  format: string,
  options?: { locale?: Locale }
): string {
  const locale = options?.locale ?? es;
  return formatFns(date, format, { locale });
}

export function resolveBrowserLocale(): Locale {
  if (typeof window === "undefined") return es;
  const lang = navigator.language.toLowerCase();
  if (lang.startsWith("es")) return es;
  return enUS;
}
